import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator, Validators } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { LanguageService } from '../../service/language.service';
import { InputControlBase } from '../forms/input-control.base';
import { ModelBase } from './../../model/model-base';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutocompleteComponent extends InputControlBase implements OnChanges, Validator {
  constructor(private _language: LanguageService) {
    super();
  }

  private _itemsSource: ModelBase[];
  @Input() clearOthers: boolean;
  @Input() set itemsSource(items: ModelBase[]) {
    this._itemsSource = items;
    if (this.control && this.control.value) {
      let correctItem = this._itemsSource.find(val => val === this.control.value);
      if (!correctItem) {
        correctItem = this._itemsSource.find(val => val.id === this.control.value.id);
        if (correctItem) {
          this.control.setValue(correctItem);
        }
      }
    }
  }

  get itemsSource(): ModelBase[] {
    return this._itemsSource;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    return typeof control.value === 'string'
      ? {
          value: {
            message: 'COMMON.INCORRECT_VALUE',
            params: {}
          }
        }
      : null;
  }

  private _subj: Subject<any[]> = new Subject();
  private _subscription: Subscription = new Subscription();
  filteredItems: Observable<any[]> = this._subj.asObservable();

  getItemCaption(item: ModelBase): string {
    if (item instanceof ModelBase) {
      return item.toAutocompleteValue('list', this._language.currentCultureLang);
    }
    return '';
  }

  onBlur() {
    if (!(this.control.value instanceof ModelBase)) {
      if (typeof this.control.value === 'string') {
        const content = this.control.value.toLowerCase();
        if (this.itemsSource) {
          const match = this.itemsSource.find(item => this.getItemCaption(item).toLowerCase() === content);
          if (match) {
            this.control.setValue(match);
            return;
          }

          const matches = this.filterItems(content);
          if (matches.length === 1) this.control.setValue(matches[0]);
        }
      }
    }
  }

  getSelectedItemCaption(selectedValue: ModelBase | string): string {
    if (selectedValue instanceof ModelBase) {
      return selectedValue.toAutocompleteValue('field', this._language.currentCultureLang);
    }
    return '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemsSource']) {
      this._subj.next(this.itemsSource);
    }
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  private filterItems(value: string): ModelBase[] {
    return this.itemsSource.filter(item => {
      const caption = item.toAutocompleteValue('list', this._language.currentCultureLang).toLowerCase();
      return caption.includes(typeof value === 'string' ? value.toLowerCase().trim() : '');
    });
  }

  ngOnInit() {
    this.control.validator = Validators.compose([this.control.validator, this.validate]);
    this._subscription.add(
      this.control.valueChanges.subscribe(value => {
        if (!this.itemsSource) {
          this._subj.next([]);
          return;
        }
        if (value instanceof ModelBase) {
          this._subj.next(this.itemsSource.filter(item => item.id === value.id));
        }
        this._subj.next(value ? this.filterItems(value) : this.itemsSource.slice());
      })
    );
  }

  get showClearThis(): boolean {
    return !this.control.isReadonly;
  }

  get showClearOthers(): boolean {
    if (!this.clearOthers) {
      return false;
    }
    return Object.keys(this.control.parent.controls).length > 1 && (this.control.value || this.control.value === 0);
  }

  addonClicked(): boolean {
    for (let controlName of Object.keys(this.control.parent.controls)) {
      let currentControl = this.control.parent.get(controlName);
      if (currentControl !== this.control) {
        currentControl.setValue(undefined);
      }
    }
    // this.addonClick.emit(this.control);
    return false;
  }

  clearBtnClicked(): boolean {
    // this.onClearBtnMouseLeave();
    this.control.setValue(null);
    this.control.markAsDirty();
    // for (let controlName of Object.keys(this.control.parent.controls)) {
    // let currentControl = this.control.parent.get(controlName);
    // if (currentControl === this.control) {
    // currentControl.setValue(undefined);
    // }
    // }
    // this.addonClick.emit(this.control);
    return false;
  }
}
